module.exports = __webpack_public_path__ + "static/media/whatsapp-bg.edda1181.webp";